import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React, { useCallback } from "react";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";
import { BoxOwnerSelector } from "./BoxOwnerSelector";
import { ShowAllOrgCustomersCheckbox } from "./ShowAllOrgCustomersCheckbox";
import { AddOwnerButton } from "./AddOwnerButton";

export function AddOwnerDialog() {
    const {
        openAddOwnerDialog,
        setOpenAddOwnerDialog,
        setShowOrgCustomers,
        box,
    } = useAddOwnerFlow();

    const handleClose = useCallback(() => {
        setOpenAddOwnerDialog(false);
        setShowOrgCustomers(false);
    }, []);

    return (
        <Dialog
            open={openAddOwnerDialog}
            onClose={handleClose}
        >
            <DialogTitle>
                Add box owner
            </DialogTitle>

            <DialogContent
                style={{
                    minHeight: "400px",
                    minWidth: "400px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
            >
                {!box.isBankBox && (
                    <ShowAllOrgCustomersCheckbox />
                )}

                <BoxOwnerSelector />
            </DialogContent>

            <DialogActions style={{ gap: "10px" }}>
                <Button
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                >
                    Cancel
                </Button>

                <AddOwnerButton />
            </DialogActions>
        </Dialog>
    );
}
